import { useState } from 'react';
import { useSelector } from 'react-redux';

import { doRequest } from '@r1-frontend/do-request';
import {
    ERequestStatus,
    requestByConnection,
    RequestDto,
    ResponseDto,
} from '@r1-frontend/api-domru/api-request/v1/user/request-by-connection';

import { ACTIONS } from '@r1-frontend/shared/constants/analytics';

import { dataLayerForCBPhonePush } from '~/src/helpers/eventsForDataLayer';
import { selectCsrf } from '~/src/store/selectors/auth/selectCsrf';

interface IDoSubmit {
    name: string,
    phone: string,
    label: string,
}

interface IDoSubmitState {
    message: string | null,
    isLoading: boolean,
    status: ERequestStatus | undefined,
}

const useSubmitAuthForm = (isPopup = false) => {
    const csrf = useSelector(selectCsrf);

    const [state, setState] = useState<IDoSubmitState>({
        message: null,
        isLoading: false,
        status: undefined,
    });

    const doSubmit = async({ name, phone, label }: IDoSubmit) => {
        setState(prevState => ({ ...prevState, isLoading: true }));

        const dataParams: RequestDto = {
            petition: 'create_request',
            fio: name,
            phone: phone,
            product_id: [5],
            tv_equipment_id: [80491],
            csrf,
        };
        const resp = await doRequest.apiRequest<ResponseDto>(
            requestByConnection(dataParams),
        );
        if (resp.isSuccess) {
            const { status, message } = resp.payload;
            dataLayerForCBPhonePush({
                action: ACTIONS.success,
                isPopup,
                option: status ? label ?? '' : `${label} | ${message}`,
            });
            setState({
                message,
                status: status ? ERequestStatus.success : ERequestStatus.error,
                isLoading: false,
            });
        } else {
            setState({
                message: 'Не удалось отправить заявку. Пожалуйста, попробуйте еще раз.',
                status: ERequestStatus.error,
                isLoading: false,
            });

            dataLayerForCBPhonePush({
                requestId: null,
                action: ACTIONS.error,
            });
        }
    };

    return [state, doSubmit];
};

export default useSubmitAuthForm;
